"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildListingsProduct = exports.buildListingsRatings = exports.buildListingsPartner = void 0;
const buildListingsPartner = () => {
    return {
        links: [],
        name: '',
        shortcode: '',
    };
};
exports.buildListingsPartner = buildListingsPartner;
const buildListingsRatings = () => {
    return {
        ratingHistogram: [],
        averageRating: 0,
        ratingCount: 0,
    };
};
exports.buildListingsRatings = buildListingsRatings;
const buildListingsProduct = (overrides = {}) => {
    const defaultRatings = (0, exports.buildListingsRatings)();
    const defaultPartner = (0, exports.buildListingsPartner)();
    return Object.assign({ attributes: {}, available: false, code: 0, freeDomesticDelivery: false, images: [{ href: '', gravity: '', title: '' }], inventoryStatus: 'in_stock', isExpandedSearch: false, isNew: false, links: [{ rel: '', href: '', title: '' }], lowCommitmentProductFlag: false, lowCommitmentProductType: '', partner: defaultPartner, preSalePrices: [], prices: [], price: { amount: 0, currency: '', exponent: 2 }, purchasable: false, ratings: defaultRatings, title: '', isSponsored: false, onSale: false, salePercentage: 0 }, overrides);
};
exports.buildListingsProduct = buildListingsProduct;
